import "./newTicketClosed.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import {calculateTimeAgingInMinutes} from "../../services/help";
import newRequest from "../../context/newRequest";


const NewTicketClosed = ({ inputs, title }) => {
  const [ticketSolved, setTicketSolved] = useState({});
  const [ticketClosed, setTicketClosed] = useState({});
  const [sending, setSending] = useState("");
  const { ticketId } = useParams();
  const user = localStorage.getItem("user");
  const { data, loading, error } = useFetch(`/solve/${ticketId}`);
  const navigate = useNavigate();

  useEffect(() => {
    setTicketSolved(data);
  }, [data]);

  const time = calculateTimeAgingInMinutes(ticketSolved.up_time, ticketSolved.down_time)


  const handleChange = (e) => {
    setTicketClosed((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };


  const handleClick = async (e) => {
    e.preventDefault();
    setSending("On Submit")
    try {
      const newTicketClosed = {
        ...ticketClosed,
        tt_aging : time
      };
      const res= await newRequest.post(`/closed/${ticketId}`, newTicketClosed, {
        // headers
        headers: {
          'Authorization': `$Bearer ${user.token}`
        },
      });
      setSending("OnSending...")
      if (res.status == 200) {
        setSending("Submit Data Berhasil")
        navigate(`/closed/${ticketId}`);
      }
    } catch (err) {
      setSending(err.response.data.errors)
    }
  };
  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <form>
              <div className="formInput">

                {inputs.map((input) => (
                    <div className="formInput" key={input.id}>
                      <label>{input.label}</label>
                      <input type={input.type} placeholder={input.placeholder} onChange={handleChange} id={input.id}/>
                    </div>
                ))}
              </div>
            </form>
            <button onClick={handleClick}>Send</button>
          </div>
        </div>
        {sending && <p className="error">{sending}</p>}
      </div>
    </div>
  );
};

export default NewTicketClosed;
